import template from './cardAvatar.html';
import controller from './cardAvatar.controller';
import './cardAvatar.scss';

let cardAvatarComponent = {
  restrict: 'E',
  bindings: {
    employee: '<',
  },
  template,
  controller,
};

export default cardAvatarComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardAvatar/cardAvatar.component.js